<template>
	<div class="screen-wrapper-newbox11">
		<div style="height:80px;width:100%" v-if="fromUser == 'guizhou'"></div>
	        <div class="screen screenBg" id="screen">
	            <div class="demo-root">
					<MyHeader>
					</MyHeader>
	                <main style="padding-top: 60px">
	                    <div class="demo-left">
							<indexLeft></indexLeft>
						</div>
	                    <div class="demo-center">
							<indexCenter></indexCenter>
						</div>
	                    <div class="demo-right">
							<indexRight></indexRight>
						</div>
	                </main>
	            </div>
				<!-- <myFooter></myFooter> -->
	        </div>
	    </div>
</template>

<script>
	import MyHeader from '@/views/components/headerv.vue'
	import myFooter from '@/views/exposition/components/myFooter.vue'
	import { dataInterface } from '@/api/dataInterfaceApi'
	import indexLeft from '@/views/photovoltaicStation/components/indexLeft.vue'
	import indexCenter from '@/views/photovoltaicStation/components/indexCenter.vue'
	import indexRight from '@/views/photovoltaicStation/components/indexRight.vue'
	export default{
		components: {
			MyHeader,
			myFooter,
			indexLeft,
			indexCenter,
			indexRight
		},
		data() {
			return {
				pageInterval: null,
				intervalNum: 40,
				intervalNumSet: 100,
				fromUser: '',
				options: [],
				showFullScreen: true,
				choosed: 1,
				nowDate: "", // 当前日期
				nowTime: "", // 当前时间
				nowWeek: "", // 当前星期
				value1: "",
				value2: "",
				value3: "",
				options:[],
				harbourid: '',
				choosetime: '',
				timetpye: '',
				timer: '',
				router: '',
				changeMapBtn: false,
				end:false
			}
		},
		beforeCreate() {
			let fromPath = localStorage.getItem('bigScreen::fromPath')
			let playCount = parseInt(localStorage.getItem('bigScreen::playCount') || 0, 10)
			if(fromPath && ++playCount >= 2) {
				localStorage.setItem('bigScreen::playCount', '0')
				localStorage.setItem('bigScreen::fromPath', '')
				location.reload()
			} else {
				localStorage.setItem('bigScreen::playCount', playCount + '')
			}
		},
		mounted(){
			this.$EventBus.$on('isActiveEnd', (isActiveEnd) => {
				if (isActiveEnd) {
					this.end = false;
				} else {
					this.end = true;
				}
			})
			console.log('this.$route===========', this.$route)
			let { fromUser, scaleY } = this.$route.query
			fromUser ? sessionStorage.setItem('fromUser', fromUser) : ''
			scaleY ? localStorage.setItem('bigScreen::scaleY', scaleY) : ''

			let that = this
			this.fromUser = sessionStorage.getItem('fromUser')
			document.title = '移动能源光储充换车云一体化大屏'
			//初始化自适应  ----在刚显示的时候就开始适配一次
			that.handleScreenAuto();
			//绑定自适应函数   ---防止浏览器栏变化后不再适配
			window.onresize = (function(){
				that.handleScreenAuto()
			});

			// 获取电港列表
			// this.getharbour()
			
			this.pageInterval = null
        	if(sessionStorage.getItem('fromUser') != 'guizhou' && sessionStorage.getItem('fromUser') != 'suzhou') {
				// this.pageInterval = setInterval(() => {
				// 	if(this.end) return;
				// 	this.intervalNum--
				// 	if(this.intervalNum < 0 ) {
				// 		if(localStorage.getItem('IntervalStop') == 'stop') {
				// 			return
				// 		}
				// 		// let localName = localStorage.getItem('exposition::pathName')
				// 		// this.$router.push({
				// 		// 	path: `/${localName || 'changingElectricity'}`
				// 		// })
				// 		this.$router.replace({
				// 			path: 'Intelligence',
				// 			// query: {
				// 			// 	stationId: '581abc7ea6ce47668a3f03eba90523de',
				// 			// 	type: '1'
				// 			// }
				// 		})
				// 	}
				// }, 1000)
	
			// 	document.onmousemove = ((event) => {
			// 		// console.log(event)
			// 		this.intervalNum = this.intervalNumSet
			// 	})
			}

		},
		deleted(){
			window.onresize = null;
		},
		methods: {
			// 获取电港列表
			// getharbour() {
			// 	dataInterface.fetchDataInterface('50cb31a4830848049821b3c755c9c8c4').then((res) => {
			// 		// console.log(res, '电港列表')
			// 		this.options = res
			// 		if(localStorage.getItem('harbour_id')) {
			// 			this.harbourid = localStorage.getItem('harbour_id') ? localStorage.getItem('harbour_id') : ''
			// 		} else {
			// 			localStorage.setItem('harbour_id', res[0].id)
			// 		}
			// 		setTimeout(()=>{
			// 			// this.$bus.$emit('onfangdiangonglv')
			// 			// this.$bus.$emit('offCloseFunction')
			// 			this.getFacility()
			// 		},3000)
			// 	}).catch((err) => {
			// 		console.log(err);
			// 	});
			// },
			// 更改电港
			changeHarBourid() {
				console.log(55566)
				localStorage.setItem('harbour_id', this.harbourid)
				// this.getFacility()
				this.$bus.$emit('onfangdiangonglv')
			},
			//数据大屏自适应函数
			handleScreenAuto(){
				const designDraftWidth = 3840;//设计稿的宽度
				const designDraftHeight = 1620;//设计稿的高度
				//根据屏幕的变化适配的比例
				const scale = document.documentElement.clientWidth / document.documentElement.clientHeight < designDraftWidth / designDraftHeight ?
					(document.documentElement.clientWidth / designDraftWidth) :
					(document.documentElement.clientHeight / designDraftHeight);
				//缩放比例
				
				console.log(scale)

				// document.querySelector('#screen').style.transform = `scale(${scale}) translate(-50%)`;
				let scaleY = parseFloat(localStorage.getItem('bigScreen::scaleY')) || 1
				if(sessionStorage.getItem('fromUser') == 'guizhou') {
					document.querySelector('#screen').style.transform = `scale(${scale}, ${scale * 1.6}) translate(-50%)`;
				} else {
					document.querySelector('#screen').style.transform = `scale(${scale}, ${scale * scaleY}) translate(-50%)`;
				}
				
			},
			changetime(type) {
				if(type == 1) {
					localStorage.setItem('changeDataNuber', this.value1)
					this.choosetime = this.value1
					this.value2 = ''
					this.value3 = ''
					localStorage.setItem('typeTime', '日')
				} else if(type == 2){
					localStorage.setItem('changeDataNuber', this.value2)
					this.choosetime = this.value2
					this.value1 = ''
					this.value3 = ''
					localStorage.setItem('typeTime', '月')
				}  else if(type == 3){
					localStorage.setItem('changeDataNuber', this.value3)
					this.choosetime = this.value3
					this.value1 = ''
					this.value2 = ''
					localStorage.setItem('typeTime', '年')
				} 
				this.choosed = type
				this.$bus.$emit('onfangdiangonglv')
			},
		},
		destroyed() {
			clearInterval(this.pageInterval)
		}
	}
</script>

<style lang="scss" scope>
	@import '@/assets/scss/pc.scss';
	@import '@/assets/scss/main-map.scss';
	@font-face {
		font-family: 'DS-Digital-Bold';
		src: url('~@/assets/font/DS-Digital-Bold.ttf');
	}

	.screen-wrapper-newbox11 {
	    height: 100%;
	    width: 100%;
		font-size: 16px;
		color: #ffffff;
		.DS-Digital-Bold{
			font-family: "DS-Digital-Bold";
		}
		.screenBg{
			background-image: url("~@/assets/images/exposition/senceBg15.png");
			background-repeat: no-repeat;
			background-size: 100% 100%;
			background-position: 0px 0px;
		}
	    .screen {
			overflow: hidden;
	        display: inline-block;
	        width: 3840px;
	        height: 1620px;
	        transform-origin: 0 0;
	        position: absolute;
	        left: 50%;
	        .demo-root{
	            header{
	                width: 3840px;
	                height: 70px;
	                text-align: center;
	            }
	            main{
	                display: flex;
	                .demo-center{
						// width: 1940px;
						flex: 1;
	                }
	            }
	            footer{
	                width: 100%;
	                height: 100px;
	                font-size: 40px;
	                text-align: center;
	                line-height: 100px;
	                background: rgba(19, 211, 115, 0.3);
	            }
	        }
	    }
	}
	.choose{
		width: 480px;
		height: 40px;
		display: flex;
		justify-content: space-between;
		position: absolute;
		right: 20px;
		bottom: 90px;
		font-weight: 600;
		.choose-cell{
			cursor: pointer;
			width: 140px;
			line-height: 40px;
			text-align: center;
			background-image: url("~@/assets/images/exposition/unchoose1.png");
			position: relative;
			color: #AFAFAF;
			.text {
				font-family: "HT";
				font-size: 32px;
				margin-left: 38px;
				line-height: 30px;
				}
			.pickyear{
				position: absolute;
				left: 0;
				top:0;
				width: 140px;
				opacity: 0;
			}
			.DS-Digital-Bold{
				font-family: "DS-Digital-Bold";
			}
		}
		.choosedindex{
			background-image: url("~@/assets/images/exposition/choosed1.png");
			color: #2983cc;
		}
	}
</style>

